export default __webpack_public_path__ + "static/logo-de-2b0f6972901dba473dad056d0a4c7605.svg";